// utils/posSettings.js

import { DEFAULT_CURRENCY } from './currency';

export const SETTINGS_STORAGE_KEY = 'pos-settings';

export const defaultSettings = {
  serviceChargeEnabled: true,
  gratuityEnabled: true,
  taxExemptionEnabled: true,
  currencyCode: DEFAULT_CURRENCY,
  receiptPrintDefault: true,
  receiptEmailDefault: false,
  rememberCustomerDefault: false,
};

export function loadSettings() {
  const saved = localStorage.getItem(SETTINGS_STORAGE_KEY);
  if (!saved) return { ...defaultSettings };
  try {
    const parsed = JSON.parse(saved);
    return { ...defaultSettings, ...parsed };
  } catch {
    return { ...defaultSettings };
  }
}

export function saveSettings(settings) {
  localStorage.setItem(SETTINGS_STORAGE_KEY, JSON.stringify(settings));
  window.dispatchEvent(new Event('pos-settings-changed'));
}
